// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.inline-message_inline-message_c8YGH {
    color: var(--menu-bar-foreground);
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: .8125rem;
    padding: 0 0.5rem;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.inline-message_success_ovPLP {
    color: var(--ui-white-dim);
}

.inline-message_info_RsKL0 {
    color: var(--menu-bar-foreground);
}

.inline-message_warn_iVBOJ {
    color: var(--error-light);
}

.inline-message_spinner_soeyU {
    margin-right: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/alerts/inline-message.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;IACI,iCAAiC;IACjC,2DAA2D;IAC3D,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.inline-message {\n    color: var(--menu-bar-foreground);\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    font-size: .8125rem;\n    padding: 0 0.5rem;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.success {\n    color: var(--ui-white-dim);\n}\n\n.info {\n    color: var(--menu-bar-foreground);\n}\n\n.warn {\n    color: var(--error-light);\n}\n\n.spinner {\n    margin-right: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inline-message": `inline-message_inline-message_c8YGH`,
	"inlineMessage": `inline-message_inline-message_c8YGH`,
	"success": `inline-message_success_ovPLP`,
	"info": `inline-message_info_RsKL0`,
	"warn": `inline-message_warn_iVBOJ`,
	"spinner": `inline-message_spinner_soeyU`
};
export default ___CSS_LOADER_EXPORT___;
